<template>
  <div class="calendar-modal modal-container">
    <div class="modal-wrapper">
      <div
        class="row h-75"
        style="padding-top: 50px; padding-bottom: 50px;">
        <div
          class="col-sm-5 d-flex justify-content-center"
          style="border-right:.5px solid #939eab;">
          <div class="elements">
            <div class="element-detail-image">
              <img
                :src="getImageURL(abr)"
                class="img-fluid">
            </div>
            <div class="image-name text-center">
              <h3
                v-if="name"
                class="elementName">{{ name }}</h3>
              <p v-else>No title</p>
            </div>
          </div>
        </div>
        <div class="col-sm-6 d-block justify-content-center">
          <div class="d-block text-center mt-5">
            <div class="d-inline-block">
              <h5 v-if="frequency !== null && cadence !== null && days !== null">Your Element Detail</h5>
            </div>
            <div class="d-inline-block mt-2">
              <div v-if="frequency !== null && cadence !== null && days !== null">
                <h4>
                  {{ frequency }}X <span class="elementCadence"> {{ cadence }} </span>
                </h4>
                <div
                  v-if="days"
                  class="elementDaysList">
                  {{ days }}
                </div>
              </div>
              <div v-else>
                <h4>
                  This element does not have saved settings.
                </h4>
                <p>To customize settings please edit this element.</p>
              </div>
            </div>
            <div>
              <button
                class="btn btn-primary-inverse"
                @click="showModal(false)"
              >CLOSE

              </button>
              <button
                class="btn btn-primary"
                @click="showRegimenCalendarModal()"
              >
                EDIT
              </button>
            </div>
          </div>
          <div class="select-product mt-3 d-inline-block">
            <img
              :src="product.image"
              style="height: 50px;"
              class="d-inline">
            <span class="d-inline ml-2">{{ product.name }}</span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import profileMixin from "@/mixins/profileMixin";
import { mapActions, mapGetters } from 'vuex';
export default {
  name: "ShowUserCalendarElements",
  mixins: [profileMixin],
  data() {
    return {
      weekDuration: '',
      abr: '',
      name: '',
      elementId: '',
      weekCount: '',
      days: '',
      cadence: '',
      frequency: '',
      product: {},
    }
  },
  computed: {
    ...mapGetters(['modal'])
  },

  created() {
      const modalData = this.$store.state.Auth.modal.data;
      if(modalData) {
        this.prepareData(modalData);
      }
      this.option =  this.$store.state.Squarespace.productsLog[0].products;
  },

  methods: {
    ...mapActions(['saveRegimenCalendar', 'getUserWeek']),
    customLabel ({ title, desc }) {
      return `${title} – ${desc}`
    },
    setDay(data) {
        this.weekDays = data;
    },

    prepareData(data) {
        console.log('data', data);
      this.abr = data.elements.abr;
      this.name = data.elements.element_name;
      this.id = data.elements.id;
      this.type = data.elements.type;
      this.frequency = data.element_frequency;
      this.days = data.week_days;
      this.cadence = data.cadence;
    },

    getImageURL(imgABR) {
      try {
        return require('@/assets/images/icons/' + imgABR + '.png');
      } catch (e) {
        return require('@/assets/images/no-image.png');
      }
    },

    dateForm(date) {
      return this.transformDateCustom(date, 'dddd');
    },

    showRegimenCalendarModal() {
        this.showModal("RegimenCalendarModal", this.modal.data);
    }
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/modals/RegimenCalendarModal/ShowUserCalendarElements.vue